
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0b05eada!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./tabbar.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./tabbar.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0b05eada!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tabbar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tabbar/src/tabbar.vue
// module id = 577
// module chunks = 0